module.exports = __webpack_public_path__ + "static/media/openProfileArrow.f35c3348.svg";